import React from 'react'
import { AuthProvider, useAuth } from './context/AuthContext'
import Login from './components/Login'
import Dashboard from './components/Dashboard'

function AppContent() {
  const { session } = useAuth()

  if (session === undefined) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0d3d3d',
        fontFamily: "'Segoe UI', system-ui, sans-serif",
        color: '#90e0e0',
        fontSize: '15px',
        gap: '10px',
      }}>
        <span style={{ fontSize: '22px' }}>🌿</span> Loading Mysa Desk…
      </div>
    )
  }

  if (!session) {
    return <Login />
  }

  return <Dashboard />
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}
